import React from 'react';
import {useWatch} from "react-hook-form";
import {getActiveClassName} from "v4/layouts/FormEntityLayout/components/FormEntityLayoutForm/formEntityLayoutForm.utils";

export default function FormEntityFieldLabel({name, htmlFor, children}) {
    const value = useWatch({name});

    return (
        <label htmlFor={htmlFor} className={getActiveClassName(value)}>
            {children}
        </label>
    );
}
